module.exports = __webpack_public_path__ + "static/media/go_icon.27960a91.svg";